// Service for managing jobs using Firebase Firestore
import {
  addJob as firestoreAddJob,
  getJobs as firestoreGetJobs,
  updateJob as firestoreUpdateJob,
  deleteJob as firestoreDeleteJob,
  Job
} from '../firebase/firestore';
import { onSnapshot, collection, query, orderBy } from 'firebase/firestore';

import { db } from '../firebase/firebase-config';

// Re-export the Job interface from firestore
export type { Job };

// Add a new job
export const addJob = async (job: Omit<Job, 'id' | 'createdAt' | 'updatedAt'>): Promise<string> => {
  return await firestoreAddJob(job);
};

// Get all jobs
export const getJobs = async (): Promise<Job[]> => {
  return await firestoreGetJobs();
};

// Listen to jobs changes in real-time
export const subscribeToJobs = (callback: (jobs: Job[]) => void): (() => void) => {
  const q = query(collection(db, "jobs"), orderBy("createdAt", "desc"));
  
  return onSnapshot(q, (snapshot) => {
    const jobs = snapshot.docs.map(doc => ({
      id: doc.id,
      ...doc.data()
    } as Job));
    callback(jobs);
  });
};

// Update a job
export const updateJob = async (id: string, updates: Partial<Job>): Promise<void> => {
  return await firestoreUpdateJob(id, updates);
};

// Delete a job
export const deleteJob = async (id: string): Promise<void> => {
  return await firestoreDeleteJob(id);
};